/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import {
  EllipsisVerticalIcon,
  PencilSquareIcon,
  PhotoIcon,
  ChatBubbleBottomCenterIcon,
} from "@heroicons/react/24/outline";

import classNames from "src/utils/ClassnameUtils";

/**
 * The Result component
 *
 * @author Thais Watanabe
 */
const Result = (props) => {
  const {
    openEdit,
    openObs,
    selectedItem,
    selectedResult,
    turbineInspection,
    inspection,
    lastTurbineInspections,
  } = props;

  return (
    <Menu as="div" className="relative inline-block text-left print:hidden">
      <div>
        <Menu.Button className="rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-teal-500">
          <span className="sr-only">開く</span>
          <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          static
          className="z-20 origin-top-left absolute left-0 mt-2 w-44 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
        >
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "w-full group flex items-center px-4 py-2 text-sm"
                  )}
                  role="menuitem"
                  onClick={() => {
                    openEdit(selectedItem, selectedResult);
                  }}
                >
                  {/* <!-- Heroicon name: pencil-alt --> */}
                  <PencilSquareIcon
                    className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                  修正する
                </button>
              )}
            </Menu.Item>
          </div>
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <button
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "w-full group flex items-center px-4 py-2 text-sm"
                  )}
                  role="menuitem"
                  onClick={() => {
                    openObs(selectedItem, selectedResult);
                  }}
                >
                  {/* <!-- Heroicon name: pencil-alt --> */}
                  <ChatBubbleBottomCenterIcon
                    className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                  備考を見る
                </button>
              )}
            </Menu.Item>
          </div>
          <div className="py-1">
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="/photo"
                  state={{
                    selectedItem: selectedItem,
                    selectedResult: selectedResult,
                    inspection: inspection,
                    turbineInspection: turbineInspection,
                    lastTurbineInspections: lastTurbineInspections,
                  }}
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "group flex items-center px-4 py-2 text-sm"
                  )}
                  role="menuitem"
                >
                  {/* <!-- Heroicon name: photograph --> */}
                  <PhotoIcon
                    className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                  写真を見る
                </Link>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default Result;
